export default "__VITE_ASSET__C9_YZXGT__"